import _ from 'lodash';
import { getFirstObject } from '../../common/convert';
import { getUrlFile } from '../../components/imaging/imageHelpers';
import { gEnums } from '../../enums/globalEnums';
import { approveStorageFilesToDatabase, updateStorageFilesToDatabase } from '../../storage/documentStorageHelpers';
import { deleteStorageFiles, removeFilesFromStorage } from '../../storage/removeStorage';
import { _storageSettings } from '../../storage/storageHelpers';
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from './reducerHelpers/dispatchProps';

const rts = {
  handleApprove_image: 'handleApprove_image',
  handleApprove_selected: 'handleApprove_selected',
  handleBigImage: 'handleBigImage',
  handleClear_currentGalleryItems: 'handleClear_currentGalleryItems',
  handleClear_gallery: 'handleClear_gallery',
  handleClick_image: 'handleClick_image',
  handleClose_bigImage: 'handleClose_bigImage',
  handleDelete_selected: 'handleDelete_selected',
  handleDelete_storageItem: 'handleDelete_storageItem',
  handleGet_docsFromDatabase: 'handleGet_docsFromDatabase',
  handleGet_galleryAny: 'handleGet_galleryAny',
  handleGet_galleryFolders: 'handleGet_galleryFolders',
  handleGet_galleryImages: 'handleGet_galleryImages',
  handleGet_globalStorageFiles: 'handleGet_globalStorageFiles',
  handleGet_profileStorageFile: 'handleGet_profileStorageFile',
  handleGet_profileStorageFiles: 'handleGet_profileStorageFiles',
  handlePermissions: 'handlePermissions',
  handleRemove_filesFromStorage: 'handleRemove_filesFromStorage',
  handleResponse_getAny: 'handleResponse_getAny',
  handleSelect_image: 'handleSelect_image',
  handleSet_imageEdit: 'handleSet_imageEdit',
  handleSet_galleryFolders: 'handleSet_galleryFolders',
  handleSet_manifestFiles: 'handleSet_manifestFiles',
  handleSet_pagePdfs: 'handleSet_pagePdfs',
  handleSet_profile: 'handleSet_profile',
  handleSet_profileStorageFile: 'handleSet_profileStorageFile',
  handleSet_profileStorageFiles: 'handleSet_profileStorageFiles',
  handleSet_fileOptionType: 'handleSet_fileOptionType',
  handleSet_storageType: 'handleSet_storageType',
  handleSet_viewItemType: 'handleSet_viewItemType',
  handleSet_viewItemItem: 'handleSet_viewItemItem',
  handleShow_approvalWizard: 'handleShow_approvalWizard',
  handleStart_fetch: 'handleStart_fetch',
  handleUpdate_gallery: 'handleUpdate_gallery',
  handleSet_storageInfo: 'handleSet_storageInfo',
  handleSet_currentAssetUrls: 'handleSet_currentAssetUrls',
  ...grts,
}

export const storageReducer = (state, action) => {

  const { type, dispatch, manifestFiles, selectedKey, removeProps, profileStorageRootPath, galleryType, imageProps } = action
  const { appStorageUrlFiles, appUserCollection, appStorageUrlFiles_current, profileStorageFiles, selectedImages, selectedImageProps, pathViews, galleries } = state

  const _appStorageUrlFiles = _.cloneDeep(appStorageUrlFiles)

  const {
    handleShow_approvalWizard,
  } = storageHandlers(dispatch)

  const { galleryPaths } = _storageSettings

  let { direct, event, page, profile, profileGallery, profiles, pdf } = galleries ?? {}

  if (!direct) { direct = {} }
  if (!event) { event = {} }
  if (!page) { page = {} }
  if (!pdf) { pdf = {} }
  if (!profile) { profile = {} }
  if (!profiles) { profiles = {} }
  if (!profileGallery) { profileGallery = {} }

  switch (type) {

    case rts.handleStart_fetch:
      return { ...state, galleryFetched: action.kill ? true : false }

    case rts.handleSet_storageInfo:
      const assetFiles_global = groupGlobalFiles(action.storageInfo?._assetUrls)
      const assetFiles_pages = groupPageFiles(action.storageInfo?._assetUrls)
      const aaa = {
        global: { ...assetFiles_global },
        ...assetFiles_global,
        pages: assetFiles_pages,
        clientProfiles: action.clientProfiles
      }
      return { ...state, appStorageUrlFiles: aaa }

    //   callback for getGalleryDocumentsFromDatabase
    // case rts.handleGet_galleryAny:

    //   let caption;

    //   handlePermissions(action.sp)

    //   const { appUserAccess, storageLocationType: slt, storageType, manifestIcons, email, view, viewKey } = action.sp

    //   const { gallery_type, gallery_exists } = getExistingGallery({ handleGet_galleryFolders, storageLocationType: slt, galleries, viewKey, view, email })

    //   if (gallery_exists) {
    //     return { ...state, galleryFetched: true, galleryType: gallery_type }
    //   }

    //   switch (slt) {

    //     case gEnums.storageLocationTypes.eventGallery:
    //       getGallery_event(mainStoragepathViews, handleResponse_getAny, slt)
    //       break;

    //     case gEnums.storageLocationTypes.clientProfiles:
    //       getGallery_clientProfiles(mainStorage, pathViews, appUserCollection, null, handleResponse_getAny, slt)
    //       break;

    //     case gEnums.storageLocationTypes.profileGallery:
    //       // getGallery_appUserGallery(mainStorage, email, handleResponse_getAny, slt)
    //       break;

    //     case gEnums.storageLocationTypes.pages:
    //     case gEnums.storageLocationTypes.pageGallery:
    //       getGallery_page(mainStorage, pathViews, action.sp, handleResponse_getAny, slt)
    //       break;

    //     case gEnums.storageLocationTypes.pagePdf:
    //       getPdfs(mainStorage, pathViews, action.sp, handleResponse_getAny, slt)
    //       break;

    //     case gEnums.storageLocationTypes.profiles:
    //       handleGet_profileStorageFile(galleryPaths.profiles + '/' + appUserAccess.email)
    //       break;

    //     case gEnums.storageLocationTypes.event:
    //       switch (storageType) {
    //         case gEnums.storageTypes.manifest:
    //           if (manifestIcons) { handleSet_manifestFiles(manifestIcons) }
    //           caption = 'Manifest Icons'
    //           break;
    //         default:
    //           handleGet_globalStorageFiles(slt, storageType)
    //           caption = _.startCase(storageType) + ': (' + _.startCase(slt) + ')'
    //       }
    //       break;

    //     default:
    //       switch (storageType) {
    //         case gEnums.storageTypes.manifest:
    //           if (manifestIcons) { handleSet_manifestFiles(manifestIcons) }
    //           caption = 'Manifest Icons'
    //           break;
    //         default:
    //         // nothing
    //       }
    //   }

    //   return { ...state, caption, galleryType: gallery_type }

    case rts.handleResponse_getAny:

      const { galleryResponse: gr, nonGalleriedEmails } = action
      const { slt: _slt, galleryItems, email: _email, galleryPath } = gr ?? {}

      switch (_slt) {
        case gEnums.storageLocationTypes.eventGallery:
          // galleries.event = galleryItems
          break;

        case gEnums.storageLocationTypes.profiles:
          break;

        case gEnums.storageLocationTypes.clientProfiles:
          // galleries.profiles = galleryItems
          _appStorageUrlFiles.profiles = galleryItems
          break;

        case gEnums.storageLocationTypes.profileGallery:
          if (!profileGallery[_email]) { profileGallery[_email] = {} }
          // profileGallery[_email] = galleryItems
          // galleries.profileGallery = profileGallery
          break;

        case gEnums.storageLocationTypes.pages:

          // this is a single item
          switch (gr.galleryPath) {
            case galleryPaths.galleryDirect:
              direct[gr.viewItemKey] = galleryItems
              // galleries.direct = direct
              break;

            case galleryPaths.profiles:
              const auv = gr.appUserCollection
              if (auv) {
                // const _profile = { ...profile, ...galleryItems }
                // galleries.profile = _profile
                // galleries.profiles = _profile
              }
              break;

            default:
              direct[galleryPath] = galleryItems
              if (appUserCollection === appUserCollection) {
                _appStorageUrlFiles._profiles = galleryItems
              }
              _appStorageUrlFiles[galleryPath] = galleryItems
            // galleries.direct = direct
            // nothing
          }
          break;

        case gEnums.storageLocationTypes.pageGallery:

          const _gd = { ...galleries }

          switch (gr.galleryPath) {
            case galleryPaths.galleryPage:
              if (!page[gr.viewItemKey]) { page[gr.viewItemKey] = {} }
              if (!page[gr.viewItemKey][gr.viewKey]) { page[gr.viewItemKey][gr.viewKey] = {} }
              page[gr.viewItemKey][gr.viewKey] = gr.galleryItems
              // galleries.page = page
              break;

            case galleryPaths.profile_all:
              _gd.profile = gr.gallery
              break;
            default:
            // nothing
          }
          break;

        case gEnums.storageLocationTypes.pagePdf:
          if (!pdf[gr.viewItemKey]) { pdf[gr.viewItemKey] = {} }
          if (!pdf[gr.viewItemKey][gr.viewKey]) { pdf[gr.viewItemKey][gr.viewKey] = {} }
          pdf[gr.viewItemKey][gr.viewKey] = gr.galleryItems
          break;

        default:
        // nothing
      }

      return { ...state, galleries, galleryFetched: true, nonGalleriedEmails }

    case rts.handleClear_gallery:
      const _g = { ...galleries }
      if (_g && _g[action.galleryType]) {
        delete _g[action.galleryType]
        return { ...state, galleries: _g }
      } else {
        return { ...state, galleries: {} }
      }

    case rts.handleClear_currentGalleryItems:
      return { ...state }

    case rts.handleGet_globalStorageFiles:

      let _currentStorageFiles;

      switch (action.storageLocationType) {
        // gets the files from appStorageUrlFiles
        case gEnums.storageLocationTypes.profiles:
        case gEnums.storageLocationTypes.event:
          _currentStorageFiles = state.appStorageUrlFiles && state.appStorageUrlFiles[action.storageType] ? state.appStorageUrlFiles[action.storageType] : {}
          break;
        default:
        // nothing
      }

      return {
        ...state,
        storageLocationType: gEnums.storageLocationTypes.event,
        appStorageUrlFiles_current: _currentStorageFiles,
        selectedImages: {},
        selectedImageProps: {},
        galleryFetched: true
      }

    // case rts.handleGet_galleryFolders:
    //   get_storageForders(mainStorage, pathViews, action, handleSet_galleryFolders)
    //   return { ...state }

    case rts.handleSet_galleryFolders:
      return { ...state, galleryFolders: gr.folderItems }

    case rts.handlePermissions:
      return { ...state, ...ammendPermissions(action.sp) }

    // case rts.handleGet_profileStorageFile:
    //   getAllImagesInPath(mainStorage, profileStorageRootPath, handleSet_profileStorageFile)
    //   return { ...state, profileStorageRootPath }

    case rts.handleRemove_filesFromStorage:
      removeProps._thumbSuffix = _storageSettings.thumbSuffix
      removeFilesFromStorage(removeProps)
      return { ...state }

    case rts.handleUpdate_gallery:
      if (selectedImages) {
        updateStorageFilesToDatabase(galleries, pathViews, action.selectedImage, action.viewItem_key).then(() => {
          handleShow_approvalWizard()
        })
        return { ...state }
      }
      return { ...state }

    case rts.handleDelete_storageItem:
      const { fullImageProps } = action
      const { path: _path } = fullImageProps ?? {}
      const x = []
      if (_path) {
        x.push(_path)
        deleteStorageFiles(null, x, _storageSettings.thumbSuffix).then(() => {
          dispatch({ type: rts.updateSuccess, dispatch })
          return { ...state }
        })
      }
      return { ...state }

    case rts.handleDelete_selected:
      if (selectedImages) {
        deleteStorageFiles(appStorageUrlFiles_current, selectedImages, _storageSettings.thumbSuffix).then(() => {
          const confirmation = { success: true, title: 'Files deleted' }
          const cfs = { ...appStorageUrlFiles_current }
          Object.keys(appStorageUrlFiles_current).forEach(key => {
            delete cfs[key]
          })
          // handleGet_globalFiles()
          dispatch({ type: rts.updateSuccess, dispatch })
          return { ...state, confirmation, appStorageUrlFiles_current: cfs }
        })
      }
      return { ...state }

    case rts.handleApprove_selected:
      approveStorageFilesToDatabase(galleries, pathViews).then(() => {
        handleShow_approvalWizard()
      })
      return { ...state }

    case rts.handleGet_galleryImages:
      if (galleries) {
        const { documentName } = action
        if (galleries && galleries[galleryType] && galleries[galleryType][documentName]) {
          const items = galleries[galleryType][documentName]
          if (items) {
            const _currentGallery = {}
            switch (type) {
              case rts.handleGet_galleryImages:
                const galleryItem = _currentGallery[0]
                if (action.callback) {
                  action.callback(galleryItem)
                }
                break;
              default:
              // nothing
            }
          }
        }
      }
      return { ...state, selectedItem: null, galleryItem: null }

    case rts.handleSet_manifestFiles:
      return {
        ...state,
        storageLocationType: gEnums.storageLocationTypes.event,
        manifestFiles,
        galleryFetched: true
      }

    case rts.handleSet_profileStorageFile:
      let storageFile;
      if (action.storageFiles && Object.keys(action.storageFiles).length > 0) {
        const { item } = getFirstObject(action.storageFiles)
        storageFile = item
      }
      return {
        ...state,
        storageLocationType: gEnums.storageLocationTypes.profiles,
        profileStorageFile: storageFile,
        selectedImages: {},
        selectedImageProps: {},
      }

    case rts.handleSet_profileStorageFiles:
      return {
        ...state,
        storageLocationType: gEnums.storageLocationTypes.profiles,
        profileStorageFiles: action.storageFiles,
        selectedImages: {},
        selectedImageProps: {},
      }


    case rts.handleSet_currentAssetUrls:
      return { ...state, currentAssetUrls: action.currentAssetUrls }

    case rts.handleSet_fileOptionType:
      return { ...state, fileOptionType: action.fileOptionType, selectedImages: {}, selectedImageProps: {}, showImageEdit: false, imageProps_edit: null }

    case rts.handleSet_storageType:
      return { ...state, storageType: action.storageType, selectedImages: {}, selectedImageProps: {}, showImageEdit: false, imageProps_edit: null }

    case rts.handleSet_viewItemType:
      return { ...state, viewItemType: action.viewItemType, selectedImages: {}, selectedImageProps: {}, showImageEdit: false, imageProps_edit: null }

    case rts.handleSet_viewItemItem:
      return { ...state, viewItemItem: action.viewItemItem, selectedImages: {}, selectedImageProps: {}, showImageEdit: false, imageProps_edit: null }

    case rts.handleSet_imageEdit:
      return { ...state, showImageEdit: !state.showImageEdit, imageProps_edit: !state.showImageEdit ? imageProps : null }

    case rts.handleSelect_image:
      const { itemKey } = imageProps
      if (action.allowMultiItemSelect) {
        const sis = { ...selectedImages }
        const sips = { ...selectedImageProps }
        if (sis[itemKey]) {
          delete sis[itemKey]
          delete sips[itemKey]
        } else {
          sis[itemKey] = { selected: true }
          sips[itemKey] = action.imageProps
        }
        return { ...state, selectedImages: sis, selectedImageProps: sips, selectedImagePath: imageProps?.image_path }
      } else {
        if (selectedImages && selectedImages[itemKey]) {
          return { ...state, selectedImages: {}, selectedImageProps: {}, selectedImagePath: imageProps?.image_path }
        } else {
          const si = { [itemKey]: {} }
          const sip = { [itemKey]: {} }
          return { ...state, selectedImages: si, selectedImageProps: sip, selectedImagePath: imageProps?.image_path }
        }
      }

    case rts.handleClick_image:

      const { customMetadata, documentKey, imageKey, imageOwner, isFullGalleryItem, isProfile, path, storageLocationType } = imageProps ?? {}

      if (documentKey) {
        if (isFullGalleryItem) {
          if (galleries && galleries.page && galleries.page[documentKey]) {
            const cf = galleries.page[documentKey]
            const cfi = cf ? cf[imageKey] : null
            const { urls, uid, user } = cfi ?? {}
            const { full: url_full, thumbnail } = urls ?? {}
            if (url_full) {
              return { ...state, fullImageProps: { url: url_full, storageLocationType, documentKey, imageKey, uid, user, path, customMetadata } }
            } else if (thumbnail) {
              return { ...state, fullImageProps: { url: thumbnail, storageLocationType, documentKey, imageKey, uid, user, path, customMetadata } }
            }
          }
        } else {
          let _cf;
          const currentGallery = galleries ? galleries[documentKey] : null
          switch (documentKey) {
            case gEnums.storageLocationTypes.pages:
              _cf = currentGallery
              break;
            case gEnums.storageLocationTypes.profileGallery:
              _cf = currentGallery && currentGallery[imageOwner] ? currentGallery[imageOwner] : null
              _cf = _cf && _cf[imageKey] ? _cf[imageKey] : null
              break;
            default:
              _cf = currentGallery && currentGallery[imageKey] ? currentGallery[imageKey] : null
          }
          if (_cf) {
            const { urls, uid, user } = _cf ?? {}
            const { full: url_full, thumbnail } = urls ?? {}
            if (url_full) {
              return { ...state, fullImageProps: { url: url_full, storageLocationType, documentKey, imageKey, uid, user, path, customMetadata, imageOwner } }
            } else if (thumbnail) {
              return { ...state, fullImageProps: { url: thumbnail, storageLocationType, documentKey, imageKey, uid, user, path, customMetadata, imageOwner } }
            }
          }
        }
      } else {
        if (isProfile) {
          const prf = profileStorageFiles[imageKey]
          const { urls, uid, user } = prf ?? {}
          const { full: url_full, thumbnail } = urls ?? {}
          if (url_full) {
            return { ...state, fullImageProps: { url: url_full, storageLocationType, documentKey, imageKey, uid, user, path, customMetadata } }
          } else if (thumbnail) {
            return { ...state, fullImageProps: { url: thumbnail, storageLocationType, documentKey, imageKey, uid, user, path, customMetadata } }
          }
        }
      }
      return { ...state, imageKey }

    case rts.handleBigImage:
      return { ...state, fullImageProps }

    case rts.handleClose_bigImage:
      return { ...state, fullImageProps: null, showImageEdit: false }

    case rts.handleApprove_image:
      const _galleries = galleries ? { ...galleries } : {}
      const { page: gallery_page } = _galleries ?? {}
      if (gallery_page) {
        const { documentKey } = action
        if (gallery_page[documentKey] && gallery_page[documentKey][selectedKey]) {
          gallery_page[documentKey][selectedKey].approved = !gallery_page[documentKey][selectedKey].approved
        }
      }
      return { ...state, galleries: _galleries }

    case rts.handleSet_profile:
      return { ...state }

    case rts.handleShow_approvalWizard:
      return { ...state, showApprovalWizard: !state.showApprovalWizard }

    case rts.handleCloseOpenedItem:
      return { ...state, confirmation: null, updating: null, fullImageProps: null }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.handleStopUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return state
  }
}

export const storageInitialState = (initState) => {
  return { ...initState, storagePermissions: {}, selectedImages: {}, selectedImageProps: {}, galleries: {}, appStorageUrlFiles: {} }
};

export const storageHandlers = (dispatch) => {
  return {
    handleSet_storageInfo: (storageInfo, clientProfiles) => { dispatch({ type: rts.handleSet_storageInfo, storageInfo, clientProfiles, dispatch }) },
    handleApprove_image: (selectedKey, documentKey) => { dispatch({ type: rts.handleApprove_image, selectedKey, documentKey, dispatch }) },
    handleApprove_selected: () => { dispatch({ type: rts.handleApprove_selected, dispatch }) },
    handleBigImage: (bigImage) => { dispatch({ type: rts.handleBigImage, bigImage, dispatch }) },
    handleClear_currentGalleryItems: () => { dispatch({ type: rts.handleClear_currentGalleryItems, dispatch }) },
    handleClear_gallery: (galleryType) => { dispatch({ type: rts.handleClear_gallery, dispatch, galleryType }) },
    handleClick_image: (imageProps) => { dispatch({ type: rts.handleClick_image, dispatch, imageProps }) },
    handleClose_bigImage: () => { dispatch({ type: rts.handleClose_bigImage, dispatch }) },
    handleDelete_selected: () => { dispatch({ type: rts.handleDelete_selected, dispatch }) },
    handleDelete_storageItem: (fullImageProps) => { dispatch({ type: rts.handleDelete_storageItem, dispatch, fullImageProps }) },
    handleGet_docsFromDatabase: (currentGalleryPath) => { dispatch({ type: rts.handleGet_docsFromDatabase, dispatch, currentGalleryPath }) },
    handleGet_galleryAny: (sp) => { dispatch({ type: rts.handleGet_galleryAny, dispatch, sp }) },
    handleGet_galleryFolders: (sp) => { dispatch({ type: rts.handleGet_galleryFolders, dispatch, sp }) },
    handleGet_galleryImages: (galleryType, documentName, documentId, callback) => { dispatch({ type: rts.handleGet_galleryImages, dispatch, galleryType, documentName, documentId, callback }) },
    handleGet_globalFiles: (pathViews, storageRootPath, _storageRootPath_client, useUnderscorePrefix, appUserCollection, appUsers, staticViews) => { dispatch({ type: rts.handleGet_globalFiles, dispatch, pathViews, storageRootPath, _storageRootPath_client, useUnderscorePrefix, appUserCollection, appUsers, staticViews }) },
    handleGet_globalStorageFiles: (storageLocationType, storageType) => { dispatch({ type: rts.handleGet_globalStorageFiles, storageLocationType, storageType, dispatch }) },
    handleGet_profileStorageFile: (profileStorageRootPath) => { dispatch({ type: rts.handleGet_profileStorageFile, dispatch, profileStorageRootPath }) },
    handleGet_profileStorageFiles: (profileStorageRootPath) => { dispatch({ type: rts.handleGet_profileStorageFiles, dispatch, profileStorageRootPath }) },
    handlePermissions: (sp) => { dispatch({ type: rts.handlePermissions, sp }) },
    handleRemove_filesFromStorage: (removeProps) => { dispatch({ type: rts.handleRemove_filesFromStorage, removeProps, dispatch }) },
    handleResponse_getAny: (galleryResponse, nonGalleriedEmails) => { dispatch({ type: rts.handleResponse_getAny, dispatch, galleryResponse, nonGalleriedEmails }) },
    handleSelect_image: (imageProps, selectedKey, documentKey, allowMultiItemSelect) => { dispatch({ type: rts.handleSelect_image, imageProps, selectedKey, documentKey, allowMultiItemSelect, dispatch }) },
    handleSet_imageEdit: (imageProps) => { dispatch({ type: rts.handleSet_imageEdit, imageProps }) },
    handleSet_galleryFolders: (galleryResponse) => { dispatch({ type: rts.handleSet_galleryFolders, galleryResponse }) },
    handleSet_manifestFiles: (manifestFiles) => { dispatch({ type: rts.handleSet_manifestFiles, manifestFiles, dispatch }) },
    handleSet_profile: () => { dispatch({ type: rts.handleSet_profile, dispatch }) },
    handleSet_profileStorageFile: (storageFiles) => { dispatch({ type: rts.handleSet_profileStorageFile, storageFiles, dispatch }) },
    handleSet_profileStorageFiles: (storageFiles) => { dispatch({ type: rts.handleSet_profileStorageFiles, storageFiles, dispatch }) },
    handleSet_fileOptionType: (fileOptionType) => { dispatch({ type: rts.handleSet_fileOptionType, fileOptionType, dispatch }) },
    handleSet_storageType: (storageType) => { dispatch({ type: rts.handleSet_storageType, storageType, dispatch }) },
    handleSet_viewItemType: (viewItemType) => { dispatch({ type: rts.handleSet_viewItemType, viewItemType, dispatch }) },
    handleSet_viewItemItem: (viewItemItem) => { dispatch({ type: rts.handleSet_viewItemItem, viewItemItem, dispatch }) },
    handleShow_approvalWizard: () => { dispatch({ type: rts.handleShow_approvalWizard, dispatch }) },
    handleStart_fetch: (kill) => { dispatch({ type: rts.handleStart_fetch, dispatch, kill }) },
    handleUpdate_gallery: (selectedImage, viewItem_key) => { dispatch({ type: rts.handleUpdate_gallery, dispatch, selectedImage, viewItem_key }) },
    handleSet_currentAssetUrls: (currentAssetUrls) => { dispatch({ type: rts.handleSet_currentAssetUrls, dispatch, currentAssetUrls }) },
    ...responseHandlers(dispatch)
  }
}

export const getGalleryImage = ({ galleries, galleryType, documentName, documentId, itemName, callback }) => {
  if (galleries && galleries[galleryType] && galleries[galleryType][documentName]) {
    const items = galleries[galleryType][documentName]
    const _image = items[documentId]
    if (_image) {
      callback(_image)
    } else {
      const image = _.find(items, function (i) { return i.path && i.path.indexOf(itemName) >= 0 })
      if (image) {
        callback(image)
      } else {
        callback()
      }
    }
  } else {
    callback()
  }
}

export const getBlobFromUrl = async (sourceDownloadURL) => {
  try {
    getUrlFile(sourceDownloadURL)
  } catch (error) {
    console.log('error', error)
  }

}

const ammendPermissions = (sp) => {

  const {
    allowAppUserUpload,
    appUserAccess,
    appUserCollection,
    galleryApprovalAccessLevel,
    galleryNeedApproval,
    pathViews,
    storageLocationType,
    uploadAccessLevel,
  } = sp

  const { appUserSessionKey, accessLevel } = appUserAccess ?? {}
  const appUserPageKey = pathViews ? pathViews[appUserCollection] : null

  const _storagePermissions = {}

  let inverted;
  let approvedOnly;
  let addIcon = 'add'

  const hasAdminLevel = accessLevel >= gEnums.accessLevels.admin.value

  switch (storageLocationType) {

    case gEnums.storageLocationTypes.profiles:
      _storagePermissions.allowUpload = true;
      inverted = true
      addIcon = 'edit outline'
      break;

    case gEnums.storageLocationTypes.profileGallery:
      _storagePermissions.allowUpload = (appUserSessionKey === appUserPageKey) || (hasAdminLevel);
      inverted = true
      _storagePermissions.iconColor = hasAdminLevel ? 'red' : null
      break;

    case gEnums.storageLocationTypes.event:
      inverted = true
      _storagePermissions.allowUpload = true;
      _storagePermissions.allowRefresh = true
      _storagePermissions.allowDelete = true
      _storagePermissions.allowHeader = true
      break;

    case gEnums.storageLocationTypes.pageGallery:
      approvedOnly = galleryNeedApproval
      _storagePermissions.allowUpload = allowAppUserUpload && (accessLevel >= uploadAccessLevel);
      break;

    case gEnums.storageLocationTypes.pages:
    case gEnums.storageLocationTypes.pagePdf:
      _storagePermissions.allowUpload = (allowAppUserUpload && (accessLevel >= uploadAccessLevel)) || (hasAdminLevel);
      _storagePermissions.allowSelect = true
      break;

    case gEnums.storageLocationTypes.fullGallery:
      if (galleryNeedApproval) {
        _storagePermissions.allowApprove = (accessLevel >= galleryApprovalAccessLevel) ? true : false
        approvedOnly = true
      } else {
        _storagePermissions.allowApprove = true
      }
      break;
    default:
    // nothing
  }

  console.log('_storagePermissions', _storagePermissions)

  return {
    storagePermissions: _storagePermissions,
    inverted,
    approvedOnly,
    addIcon,
  }

}

const getExistingGallery = (props) => {

  const { handleGet_galleryFolders, storageLocationType, galleries, viewKey, view, email } = props

  let _galleryType;

  switch (storageLocationType) {
    // case gEnums.storageLocationTypes.fullGallery:
    //   handleGet_galleryFolders()
    //   break;
    case gEnums.storageLocationTypes.clientProfile:
    case gEnums.storageLocationTypes.clientProfiles:
      _galleryType = _storageSettings.galleryTypes.profiles
      break;
    case gEnums.storageLocationTypes.event:
      _galleryType = _storageSettings.galleryTypes.event
      break;
    case gEnums.storageLocationTypes.eventGallery:
      _galleryType = _storageSettings.galleryTypes.event
      break;
    case gEnums.storageLocationTypes.pages:
      _galleryType = _storageSettings.galleryTypes.direct
      break;
    case gEnums.storageLocationTypes.pageGallery:
      _galleryType = _storageSettings.galleryTypes.pages
      break;
    case gEnums.storageLocationTypes.pagePdf:
      _galleryType = _storageSettings.galleryTypes.pdf
      break;
    case gEnums.storageLocationTypes.profiles:
      break;
    case gEnums.storageLocationTypes.profileGallery:
      _galleryType = _storageSettings.galleryTypes.profiles
      break;
    default:
    // nothing
  }

  const existingProps = {
    gallery_gallery: null,
    gallery_type: null,
    gallery_exists: false
  }

  if (_galleryType) {

    switch (storageLocationType) {

      case gEnums.storageLocationTypes.clientProfiles:
        if (galleries && galleries[_galleryType] && galleries[_galleryType]) {
          existingProps.gallery_gallery = galleries[_galleryType]
          existingProps.gallery_type = _galleryType
          existingProps.gallery_exists = true
        }
        break;

      case gEnums.storageLocationTypes.eventGallery:
        if (galleries && galleries[_galleryType] && galleries[_galleryType]) {
          existingProps.gallery_gallery = galleries[_galleryType]
          existingProps.gallery_type = _galleryType
          existingProps.gallery_exists = true
        }
        break;

      case gEnums.storageLocationTypes.profileGallery:
        if (galleries && galleries[_galleryType] && galleries[_galleryType][email]) {
          existingProps.gallery_gallery = galleries[_galleryType][email]
          existingProps.gallery_type = _galleryType
          existingProps.gallery_exists = true
        }
        break;

      case gEnums.storageLocationTypes.profiles:
        if (galleries && galleries[_galleryType] && galleries[_galleryType][email]) {
          existingProps.gallery_gallery = galleries[_galleryType][email]
          existingProps.gallery_type = _galleryType
          existingProps.gallery_exists = true
        }
        break;

      default:
        if (galleries && galleries[_galleryType] && galleries[_galleryType][view] && galleries[_galleryType][view][viewKey]) {
          existingProps.gallery_gallery = galleries[_galleryType][view][viewKey]
          existingProps.gallery_type = _galleryType
          existingProps.gallery_exists = true
        }
    }
  }

  return existingProps
}


const transformFlatToNested = (flatDoc) => {
  const result = {};

  for (const fieldPath in flatDoc) {
    const value = flatDoc[fieldPath];

    const pathParts = fieldPath.split("/");
    let current = result;

    // Walk to the parent
    for (let i = 0; i < pathParts.length; i++) {
      const part = pathParts[i];

      // Final part
      if (i === pathParts.length - 1) {
        if (Array.isArray(value)) {
          current[part] = {};

          value.forEach(({ name, url }) => {

            const isThumb = _.includes(name, '-thumb')
            const baseName = _.replace(name, '-thumb', '')

            const lastDotIndex = baseName.lastIndexOf('.');
            const baseNameS = lastDotIndex !== -1
              ? [baseName.slice(0, lastDotIndex), baseName.slice(lastDotIndex + 1)]
              : [baseName];

            const _baseName = baseNameS[0]

            current[part][_baseName] = current[part][_baseName] || {};
            current[part][_baseName].urls = current[part][_baseName].urls || {};

            // current[part][_baseName][isThumb ? "thumb" : "full"] = url;
            current[part][_baseName].urls[isThumb ? "thumbnail" : "full"] = url;

          });

        } else {
          // Not an array — copy value directly
          current[part] = value;
        }
      } else {
        // Intermediate folders
        current[part] = current[part] || {};
        current = current[part];
      }
    }
  }

  return result;

};

const getBaseName = (name) => {
  const [file] = name.split(/\.(?=[^.]+$)/);

  return file.endsWith("-thumb")
    ? file.slice(0, -6)
    : file;
};

const formatUrl = (items) => {
  const result = { full: null, thumb: null };

  _.forEach(items, (item) => {
    if (item.name.endsWith("-thumb")) {
      result.thumb = item.url;
    } else {
      result.full = item.url;
    }
  });

  return result;
};


const groupGlobalFiles = (assetUrls) => {
  const { global } = assetUrls ?? {};
  if (global) {
    return modifyGroup(global)
  }
  return global || {}

};

const groupPageFiles = (assetUrls) => {
  const { pages } = assetUrls ?? {};
  if (pages) {
    return modifyGroup(pages)
    // let _pages = {}
    // _.forEach(pages, (page, pageKey) => {
    //   if (!_pages[pageKey]) { _pages[pageKey] = {} }
    //   _.forEach(page, (pageItem, pageItemKey) => {
    //     if (!_pages[pageKey][pageItemKey]) { _pages[pageKey][pageItemKey] = [] }
    //     _pages[pageKey][pageItemKey].push({ urls: pageItem })
    //   })
    // })
    // return _pages
  }
  return pages || {}
};

const modifyGroup = (items) => {
  if (items) {
    let _items = {}
    _.forEach(items, (item, itemKey) => {
      if (!_items[itemKey]) { _items[itemKey] = {} }
      _.forEach(item, (itemItem, itemItemKey) => {
        if (!_items[itemKey][itemItemKey]) { _items[itemKey][itemItemKey] = [] }
        _items[itemKey][itemItemKey].push({ urls: itemItem })
      })
    })
    return items
  }
}